import { Typography, TypographyProps } from "@mui/material";

export function RegulationText({ sx, ...rest }: TypographyProps<"span", { component?: string }>) {
  return (
    <Typography
      variant="caption"
      data-test="message-regulation-text"
      color="text.primary"
      sx={{ maxWidth: "120ch", pt: 0.5, ...sx }}
      {...rest}
    >
      Please note that texts will only be delivered between <strong>9am-8pm</strong> in the recipient's time
      zone to ensure compliance with federal TCPA regulations.
    </Typography>
  );
}
